
export const removeAccents = (value: string): string => {
    return String(value)
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "");
};
